import BookPageContent from '@website/components/checkout/BookPageContent';
import { SalesPopupProvider } from '@website/components/SalesPopupProvider';

/**
 * Book a trip page
 *
 * A Wrapper to ensure Book Trip page ins't server side rendered at all
 *
 * Avoids the error Window is not defined.
 */
export default function BookPage() {
  return (
    <>
      <BookPageContent />
      <SalesPopupProvider bottomPosition={10} />
    </>
  );
}

export interface BookingSetSuccess {
  values: {
    quantity: number;
  };
}
